// The tab strip's footprint, as the rest of the app sees it (TGCLOUD-1839).
//
// The strip FLOATS over the bottom of the page rather than reserving height
// (see PedigreeTabBar), so anything anchored to the bottom of the viewport sits
// underneath it unless it subtracts the strip. PedigreeTabBar publishes the
// strip's height on <html> under TAB_BAR_OFFSET_VAR while at least one tab is
// open, and removes it otherwise, so TAB_BAR_OFFSET resolves to 40px with a tab
// open and to 0px with none (or with the workspace flag off, when the strip
// never mounts).
//
// One module for the name and its reader, so the setter and every consumer
// cannot drift apart. A typo in a CSS custom property name fails silently: the
// fallback kicks in and the element goes back under the strip, which is how the
// person tab's Save button was hidden in the first place.
//
// Dependency-free on purpose: the sidebar and the lock banner import it, and
// neither should pull the tab strip's component tree in with it.

export const TAB_BAR_HEIGHT = 40;

export const TAB_BAR_OFFSET_VAR = '--tabbar-offset';

export const TAB_BAR_OFFSET = `var(${TAB_BAR_OFFSET_VAR}, 0px)`;
